import { getCurrentInstance } from 'vue'
import VueRouter, { Route } from 'vue-router'

export function useRoute(): Route {
    const route = getCurrentInstance().proxy.$route;
    return route;
}

export function useRouter(): VueRouter {
    const router = getCurrentInstance().proxy.$router;
    return router;
}

export function usePageReloaded(): boolean {
    return window.performance
        .getEntriesByType('navigation')
        .map((nav) => (nav as PerformanceNavigationTiming).type)
        .includes('reload')
}

export function useOrganizationUnitId(): string {
    const route = getCurrentInstance().proxy.$route;
    return route.params.tid;
}

export function useWorkspaceId(): number {
    const route = getCurrentInstance().proxy.$route;
    return parseInt(route.params.wid);
}

export function useProjectId(): number {
    const route = getCurrentInstance().proxy.$route;
    return parseInt(route.params.pid);
}

export function useId(): string {
    const route = getCurrentInstance().proxy.$route;
    return route.params.id;
}

export function useIdsPath(): { tid: number, wid: number, pid: number, id: string } {
    const route = getCurrentInstance().proxy.$route;
    return {
        tid: parseInt(route.params.tid),
        wid: parseInt(route.params.wid),
        pid: parseInt(route.params.pid),
        id: route.params.id
    };
}